<template>
  <div>
    <div class="wrapper" style="height: 80px;">
      <div class="header-box">
        <div class="header">
          <div class="header-front">
            <el-image src="/img/zqx.a285c935.png"
              style="width: 50px;height: 50px;margin-left: 20px;"></el-image>
            <div class="lf projectName" style="margin-left:20px;font-size:20px;color: #fff;">足球行 · 城市合伙人管理系统</div>
          </div>
          <div class="bottom-info">
            <!-- <el-button class="addMatchBtn" @click="openCity"
              style="background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);">切换城市</el-button> -->
            <el-button class="addMatchBtn" @click="logout"
              style="background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);">退出登录</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="cityDialog" title="选择城市" width="80%">
    
    </el-dialog>
    <div class="content-box">
      <div class="leftMenuBox">
        <el-aside :width="width" style="flex: 1">
          <Menu :menuData="menus"></Menu>
        </el-aside>
      </div>
      <div class="content">
        <transition name="move" mode="out-in">
          <router-view>
          </router-view>
        </transition>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
import Menu from './components/Menu.vue';
import vFooter from "./components/Footer.vue";

export default {
  name: 'layout',
  components: {
    Menu, vFooter,
  },
  data() {
    return {
      cityList: [],
      matchInfo: {},
      matchFormatInfo: {},
      matchTimeInfo: {},
      cityDialog:false,
      title: '',
      currentStep: 1,
      propertyOptionList: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
        count: 0,
      },
      width: '240px',
      search: '',
      show: 1,
      isCollapse: false,
      loading: true,
      imageUrl:
        'https://football-go.oss-cn-hangzhou.aliyuncs.com/zhengwu/longgucun.png',
      showMapDialog: false,
      menus: [
        // {
        //   code: 'MatchList',
        //   children: [],
        //   name: '赛事列表',
        //   iconClass: 'zi zi_tmCvcsa mr-2',
        // },
        {
          code: 'matchData',
          children: [],
          name: '数据统计',
          iconClass: 'zi zi_copyright mr-2',
        },
        {
          code: 'InfoList',
          children: [],
          name: '入驻商户',
          iconClass: 'zi zi_copyright mr-2',
        },
        // {
        //   code: 'MatchIntroduce',
        //   children: [],
        //   name: '赛事管理',
        //   iconClass: 'zi zi_copyright mr-2',
        // },
        {
          code: 'MatchContest',
          children: [],
          name: '用户管理',
          iconClass: 'zi zi_copyright mr-2',
        },
        // {
        //   code: 'GroupLists',
        //   children: [],
        //   name: '组局管理',
        //   iconClass: 'zi zi_copyright mr-2',
        // },
        {
          code: 'MatchManage',
          children: [],
          name: '交易佣金',
          iconClass: 'zi zi_copyright mr-2',
        },
        {
          code: 'TeamControl',
          children: [],
          name: 'SaaS订阅',
          iconClass: 'zi zi_copyright mr-2',
        },
        {
          code: 'Settlement',
          children: [],
          name: '结算资料',
          iconClass: 'zi zi_copyright mr-2',
        },
        {
          code: 'TeamList',
          children: [],
          name: '收益明细',
          iconClass: 'zi zi_copyright mr-2',
        },
        {
          code: 'Marketing',
          children: [],
          name: '营销话术',
          iconClass: 'zi zi_copyright mr-2',
        },
        {
          code: 'RefereeManage',
          children: [],
          name: '技术支持',
          iconClass: 'zi zi_copyright mr-2',
        },
        // {
        //   code: 'OutsManage',
        //   children: [],
        //   name: '赛事会员版',
        //   iconClass: 'zi zi_copyright mr-2',
        // },
        // {
        //   code: 'InvitationCode',
        //   children: [],
        //   name: '邀请码',
        //   iconClass: 'zi zi_copyright mr-2',
        // },
        // {
        //   code: 'Poster',
        //   children: [],
        //   name: '参赛邀请码',
        //   iconClass: 'zi zi_copyright mr-2',
        // },
        // {
        //   code: 'Sponsor',
        //   children: [],
        //   name: '赛事管理员',
        //   iconClass: 'zi zi_copyright mr-2',
        // },
        // {
        //   code: 'InvitationCode',
        //   children: [],
        //   name: '技术支持',
        //   iconClass: 'zi zi_copyright mr-2',
        // },
      ],
    };
  },
  mounted() {

  },
  computed: {
    userInfo() {
      return JSON.parse(localStorage.getItem('user_info'));
    }
  },
  methods: {

    handleCommand(command) {
      if (command === 'logout') {
        this.logout();
      }
    },
    logout() {
      this.$confirm('确认退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        localStorage.removeItem('Authorization');
        localStorage.removeItem('user_info');
        localStorage.removeItem('currentField');
        localStorage.removeItem('matchId');
        localStorage.removeItem('currentMatchId');
        // this.$router.push({ name: 'login' });
        location.reload();
      });
    },

    openCity(){
      this.cityDialog = true
    },

    // 切换赛事
    handleMatch(item) {
      this.$confirm('确认切换赛事吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        localStorage.setItem('matchId', item.matchId);
        localStorage.setItem('currentMatchId', JSON.stringify(item));
        this.matchInfo = item
        location.reload();
      });
    },
    // 获取赛事信息
    async getMatchDetail() {
      const { res } = await this.$http.get(`/Match/MatchInfo/${this.matchInfo.matchId}`);
      this.matchTimeInfo = res.data.info;
      this.matchFormatInfo = res.data.formatInfo
      this.matchTimeInfo.beginDate = this.matchTimeInfo.beginDate.slice(0, 10)
      this.matchTimeInfo.endDate = this.matchTimeInfo.endDate.slice(0, 10)
      this.$emit('match-Type', this.matchFormatInfo.matchFormat)
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.stepFourForm = {};
      this.stepThreeForm = {};
      this.stepTwoForm = {};
      this.stepOneForm = {};
    },
    
    // 分页
    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.chooseMatchBtn();
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.chooseMatchBtn();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .header-box {
    opacity: 0.84;
    background-image: linear-gradient(1deg, #51beff, rgba(0, 157, 255, 0.219) 1%, rgba(0, 132, 211, .41) 4%, rgba(0, 127, 201, 0.219) 9%, transparent);

    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      height: 80px;
      border: none;
      line-height: 80px;

      .header-front {
        display: flex;
        align-items: center;
      }


      .logo {
        width: 50px;
        height: 50px;
        margin: 15px 0 0 15px;
        background-size: contain;
      }

      .projectName {
        font-size: 18px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 80px;
      }
    }
  }
}

.content-box {
  height: calc(100vh - 110px);
  display: flex;
  flex-direction: row;
  flex: 1;
  flex-basis: auto;
  overflow: auto;
  box-sizing: border-box;

  .leftMenuBox {
    // height: calc(100vh-20px);
    box-sizing: border-box;
    overflow: auto;
    // width: 200px;
    flex-shrink: 0;
    background-color: #0f59a331;
    // background-image: linear-gradient(1deg, #51bfff41, rgba(0, 159, 255, .45) 1%, rgba(0, 134, 211, 0.233) 4%, transparent);
  }

  .content {
    // display: flex;
    flex-direction: row;
    flex: 1;
    flex-basis: auto;
    box-sizing: border-box;
    min-width: 0;
    overflow: auto;
    padding: 20px;
  }
}

.addMatchBtn {
  width: 100px;
  height: 30px;
  color: #fff;
  background-image: linear-gradient(270deg, #00d6ea 0%, #0e6ae9 100%);
  border: none;
}

.pageMain {
  width: 100%;
  margin-top: 50px;
}

.header {
  padding: 20px 10px;
  box-sizing: border-box;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.left-menu-area {
  height: 100%;
  display: flex;
  flex-direction: column;
  // background-color: #334054;
}

.el-aside::-webkit-scrollbar {
  display: none;
}

/deep/.el-submenu .el-menu-item {
  // width: 200px;
  // background-color: #1f2d3d !important
}

/deep/.el-submenu,
/deep/.el-menu-item {
  // width: 230px;
}

/deep/ .el-submenu__title i,
/deep/.el-menu-item i {
  color: #c1cbd8;
}

// /deep/.el-submenu .el-menu-item {
//   &:hover {
//     background-image: linear-gradient(270deg, #51beff 0%, rgba(0, 159, 255, 0.45) 1%, rgba(0, 132, 211, 0.41) 4%, rgba(0, 0, 0, 0) 100%);
//   }
// }


.left-menu-top {
  width: 240px;
  height: 60px;
  display: flex;
  align-items: center;
  // background-color: #334054;
}

.left-match {
  display: flex;
  justify-content: center;
}

.bottom-info {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin: 2vh 0;
  margin-right: 20px;
}

.bottom-info img {
  width: 40px;
  height: 40px;
  margin-right: 20px;
  border-radius: 50%;
}

.slogin {
  color: #fff;
  font-size: 23px;
  font-family: 'Lucida Calligraphy', cursive, serif, sans-serif;
}

.title {
  margin-left: 10px;
  font-size: 16px;
  display: flex;
  align-items: center;
  color: darkgray;
}

.bottom-title {
  font-size: 17px;
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
}

.fixed-header {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 9;
  width: 100%;
  transition: width 0.28s;
}

.foot {
  padding-top: 12px;
  color: #fff;
  display: flex;
  justify-content: center;
  font-size: 18px;
  font-family: 'Lucida Calligraphy', cursive, serif, sans-serif;
}

.menu-bottom {
  display: flex;
  justify-content: center;
  color: #0f58a3;
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 15px;
  font-family: '微软雅黑';
}
</style>
